/* eslint-disable */
export default {
  inAMeeting: 'In riunione',
  onMyWay: 'Sto arrivando',
  callMeBackIn: 'Richiamami tra...',
  willCallYouBackIn: 'Ti richiamo tra...',
  hour: 'ora',
  min: 'min',
} as const;

// @key: @#@"inAMeeting"@#@ @source: @#@"In a meeting"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in..."@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in..."@#@
// @key: @#@"hour"@#@ @source: @#@"hour"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
